module.exports = __webpack_public_path__ + "img/HomeTop.d5122613.jpg";